<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                2023 Summer Camp 학습후기
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  2023 Summer Camp → 학습후기
                </div>
              </h5>

              <query-grid :config="config" ref="qg">
                <template #resultactions="props"
                  ><!--추후 제공예정-->

                  <div style="text-align: right">
                    <router-link to="/events/2023_Summer"
                      ><button class="btn btn-secondary">
                        신청목록
                      </button></router-link
                    >
                    <!--router-link to="/events/learningreview"><button class="btn btn-secondary">학습후기</button></router-link-->
                    <router-link to="/events/2023_Summer_view"
                      ><button class="btn btn-success">
                        학습현황
                      </button></router-link
                    >
                  </div>
                </template>
                <template #items="props">
                  <tr v-for="article in props.records" v-bind:key="article.id">
                    <td style="height: 48px">{{ article.id }}</td>
                    <td>
                      <router-link :to="'/event/2023s_Review/' + article.id">{{
                        article.title
                      }}</router-link>
                    </td>
                    <td>{{ article.biz }}</td>
                    <td>{{ article.writerid }}</td>
                    <td>
                      <router-link :to="'/event/2023s_Review/' + article.id">{{
                        article.writerName
                      }}</router-link>
                    </td>
                    <td>{{ article.created_at }}</td>
                  </tr>
                </template>
              </query-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
  },
  data: () => ({
    boards: {},
    etc: {
      board: {
        title: "",
      },
    },
    articles: [],
    selBoard: "",
    search: "",
    config: {
      name: "학습후기",
      req_endpoint: "",
      default_limit: 20,
      no_excel: true,
      search_fields: [
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
          filter_type: {
            created_at: "등록일",
            updated_at: "수정일",
          },
        },
        {
          id: "search",
          name: "키워드검색",
          type: "text",
          placeholder: "제목으로 검색",
        },
      ],
      columns: [
        {
          id: "id",
          sortable: true,
          name: "번호",
          excel_print: (v) => {
            return v.id;
          },
        },
        {
          id: "title",
          sortable: true,
          name: "제목",
          excel_print: (v) => {
            return v.title;
          },
        },
        {
          id: "biz",
          sortable: true,
          name: "캠퍼스",
          excel_print: (v) => {
            return v.biz;
          },
        },
        {
          id: "writerid",
          sortable: true,
          name: "아이디",
          excel_print: (v) => {
            return v.writerid;
          },
        },
        {
          id: "writerName",
          sortable: true,
          name: "작성자",
          excel_print: (v) => {
            return v.writerName;
          },
        },
        {
          id: "created_at",
          sortable: true,
          name: "등록일",
          excel_print: (v) => {
            return v.created_at;
          },
        },
      ],
    },
  }),
  beforeMount() {
    this.config.req_endpoint = "/articles_event/3";
    this.config.grid_parser = async (data) => {
      this.etc = data.etc;
      return {
        records: data.result,
        total: data.total,
      };
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (!this.$route.params.board) return;
        this.config.req_endpoint = "/articles_event/3";
        this.$refs.qg.search();
      }
    },
  },
};
</script>
